module.exports = __webpack_public_path__ + "static/media/filter_icon.c74059b7.svg";